import { LanguageModalActionType } from "../../types/languageModalType"

export const setLanguageModal = () => {
    return {type: LanguageModalActionType.CHANGE_VALUE_LANGUAGE_MODAL}
}

export const closeLanguageModal = () => {
    return {type: LanguageModalActionType.CLOSE_LANGUAGE_MODAL}
}